import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  get,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_MENU,
  DELETE_MENU,
  GET_ALL_MENUS,
  GET_ALL_MENU_LIST,
  GET_MENU_DETAILS,
  UPDATE_MENU,
  UPDATE_MENU_STATUS,
} from "helpers/url_helper"

export const getAll = createAsyncThunk(
  GET_ALL_MENUS,
  async payload => {
    const response = await post(GET_ALL_MENUS, payload)
    return response
  }
)

export const updateMenuStatus = createAsyncThunk(
  UPDATE_MENU_STATUS,
  async payload => {
    const response = await patch(UPDATE_MENU_STATUS, payload)
    return response
  }
)

export const addMenu = createAsyncThunk(ADD_MENU, async payload => {
  const response = await post(ADD_MENU, payload)
  return response
})

export const getMenuDetails = createAsyncThunk(
  GET_MENU_DETAILS,
  async payload => {
    const response = await post(GET_MENU_DETAILS, payload)
    return response
  }
)

export const updateMenu = createAsyncThunk(UPDATE_MENU, async payload => {
  const response = await put(UPDATE_MENU, payload)
  return response
})

export const deleteMenu = createAsyncThunk(DELETE_MENU, async payload => {
  const req = { id: payload.id, status: payload.status }
  const response = await del(`${DELETE_MENU}/${payload.id}`)
  return response
})

export const getMenuList = createAsyncThunk(
  GET_ALL_MENU_LIST,
  async payload => {
    const response = await get(GET_ALL_MENU_LIST, payload)
    return response
  }
)
